
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/closed",
      function () {
        return require("private-next-pages/closed.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/closed"])
      });
    }
  